import CrossIcon from "Assets/Icons/CrossIcon";
import Typography from "Components/CommonComponents/Typography";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const CustomModal = (props: any) => {
  return (
    <React.Fragment>
      <Modal
        zIndex={105000}
        isOpen={props.modal}
        toggle={props.toggle}
        backdrop={props.backdrop}
        centered={props.centered}
        size={props.size ? props.size : "lg"}
        fullscreen={props.fullscreen ? props.fullscreen : false}
        className={"NewModalCSS"}
      >
        <ModalHeader
          onContextMenu={(e) => e.preventDefault()}
          cssModule={{ "modal-title": "w-100" }}
        >
          <div className="d-flex justify-content-between">
            <Typography color="black" variant="h5">
              {props.title}
            </Typography>
            <CrossIcon className="cursorHoverCSS" onClick={props.toggle} />
          </div>
        </ModalHeader>
        <ModalBody>{props.children}</ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CustomModal;
